import {
  Action,
  ReducerState,
  ActionType,
  SelectionsDataType,
} from "../types/betslip";

const initState = () => ({
  selections: [] as SelectionsDataType[],
  selectionsData: "",
  selectionsCopy: [] as SelectionsDataType[],
  stake: "10",
  tabsInUse: true,
});

interface selection {
  eventid: string;
}

interface obj {
  eventid: string;
}

const betslip = (state = initState(), action: Action): ReducerState => {
  const parentURL = document.referrer
    ? document.referrer
    : window.location.ancestorOrigins?.[0];

  switch (action.type) {
    case ActionType.UPDATE_BETSLIP:
      return {
        ...state,
        selections: action.payload,
      };

    case ActionType.ADD_SELECTION_TO_BETSLIP:
      const msg = JSON.stringify({
        type: action.type,
        betslip: action.payload,
      });
      window.parent.postMessage(msg, parentURL);

      return {
        ...state,
        selections: [...state.selections, action.payload],
      };

    case ActionType.REMOVE_SELECTION_FROM_BETSLIP: {
      const newSelections = [
        ...state.selections.filter(
          (selection: selection) => selection.eventid !== action.payload.eventid
        ),
      ];
      const msg = JSON.stringify({ type: action.type, betslip: newSelections });
      window.parent.postMessage(msg, parentURL);

      return {
        ...state,
        selections: newSelections,
      };
    }

    case ActionType.UPDATE_MATCH_SELECTION: {
      const newSelections = state.selections;
      const objIndex = newSelections.findIndex(
        (obj: obj) => obj.eventid === action.payload.eventid
      );

      newSelections[objIndex].commonId = action.payload.commonId;
      newSelections[objIndex].oddsDecimal = action.payload.oddsDecimal;

      const msg = JSON.stringify({
        type: "UPDATE_SELECTION",
        betslip: action.payload,
      });

      window.parent.postMessage(msg, parentURL);

      return {
        ...state,
        selections: newSelections,
      };
    }

    case ActionType.CLEAR_BETSLIP: {
      const msg = JSON.stringify({
        type: "REMOVE_SELECTION_FROM_BETSLIP",
        betslip: [],
      });
      window.parent.postMessage(msg, parentURL);

      return {
        selections: [],
        selectionsData: "",
        selectionsCopy: [],
        stake: "10",
        tabsInUse: true,
      };
    }

    case ActionType.SET_TAB_STAKE:
      return Object.assign({}, state, {
        stake: action.payload,
        tabsInUse: true,
      });

    case ActionType.SET_OTHER_STAKE:
      return Object.assign({}, state, {
        stake: action.payload,
        tabsInUse: false,
      });

    case ActionType.SET_STAKE:
      return Object.assign({}, state, {
        stake: action.payload,
      });

    case ActionType.RESET_STAKE:
      return Object.assign({}, state, {
        stake: "10",
        tabsInUse: true,
      });

    default:
      return state;
  }
};

export default betslip;
